import { api } from './client'

// ---------- tipuri — oglindesc DTO-urile din Cipral.Application/Mentenanta/MentenantaModels.cs ----------

export type WorkOrderType = 'Corectiv' | 'Preventiv'
export type WorkOrderPriority = 'Scazuta' | 'Normala' | 'Ridicata' | 'Urgenta'
export type WorkOrderStatus = 'Deschis' | 'InLucru' | 'Rezolvat'
export type MaintenanceIntervalType = 'Zilnic' | 'Saptamanal' | 'Lunar' | 'Trimestrial' | 'Semestrial' | 'Anual'

export interface WorkOrderListItem {
  id: string; number: string; equipmentId: string; equipmentCode: string; equipmentName: string
  type: WorkOrderType; priority: WorkOrderPriority; status: WorkOrderStatus
  reportedAt: string; resolvedAt: string | null
}

export interface WorkOrderDetail {
  id: string; number: string; equipmentId: string; equipmentCode: string; equipmentName: string
  type: WorkOrderType; priority: WorkOrderPriority; status: WorkOrderStatus; description: string
  reportedByUserId: string; reportedByUserName: string; reportedAt: string
  assignedToUserId: string | null; assignedToUserName: string | null
  resolutionNotes: string | null; resolvedAt: string | null
}

export interface CreateWorkOrderPayload {
  equipmentId: string; type: WorkOrderType; priority: WorkOrderPriority; description: string; assignedToUserId: string | null
}
export interface UpdateWorkOrderPayload { priority: WorkOrderPriority; description: string; assignedToUserId: string | null }

export interface MaintenanceSchedule {
  id: string; equipmentId: string; equipmentCode: string; equipmentName: string; interventionType: string
  intervalType: MaintenanceIntervalType; lastServiceDate: string; nextDueDate: string
  preaviceDays: number; escalationDays: number; dueSoon: boolean; overdue: boolean; escalated: boolean; isActive: boolean
}

export interface SaveMaintenanceSchedulePayload {
  equipmentId: string; interventionType: string; intervalType: MaintenanceIntervalType
  lastServiceDate: string; preaviceDays: number; escalationDays: number
}

export const listWorkOrders = (params: { equipmentId?: string; status?: WorkOrderStatus } = {}) =>
  api.get<WorkOrderListItem[]>('/mentenanta/ordine-lucru', { params }).then((r) => r.data)
export const getWorkOrder = (id: string) => api.get<WorkOrderDetail>(`/mentenanta/ordine-lucru/${id}`).then((r) => r.data)
export const createWorkOrder = (payload: CreateWorkOrderPayload) =>
  api.post<{ id: string }>('/mentenanta/ordine-lucru', payload).then((r) => r.data)
export const updateWorkOrder = (id: string, payload: UpdateWorkOrderPayload) => api.put(`/mentenanta/ordine-lucru/${id}`, payload)
export const startWorkOrder = (id: string) => api.post(`/mentenanta/ordine-lucru/${id}/incepe`)
export const resolveWorkOrder = (id: string, resolutionNotes: string | null) =>
  api.post(`/mentenanta/ordine-lucru/${id}/rezolva`, { resolutionNotes })

export const listMaintenanceSchedules = () => api.get<MaintenanceSchedule[]>('/mentenanta/calendar').then((r) => r.data)
export const createMaintenanceSchedule = (payload: SaveMaintenanceSchedulePayload) =>
  api.post<{ id: string }>('/mentenanta/calendar', payload).then((r) => r.data)
export const updateMaintenanceSchedule = (id: string, payload: SaveMaintenanceSchedulePayload) =>
  api.put(`/mentenanta/calendar/${id}`, payload)
export const markMaintenanceServiceDone = (id: string, serviceDate: string) =>
  api.post(`/mentenanta/calendar/${id}/marcheaza-efectuat`, { serviceDate })
export const deactivateMaintenanceSchedule = (id: string) => api.post(`/mentenanta/calendar/${id}/dezactiveaza`)
